import {Result} from '../../resultModel'
import {
  APPOINTMENTS_BY_EXPERTID_GETURL,
  APPOINTMENTS_BY_PATIENTID_GETURL,
  APPOINTMENTS_BY_ID_DELETEURL,
  APPOINTMENTS_UPDATE_PUTURL,
  APPOINTMENTS_CREATE_APPOINTMENT_POSTURL,
  APPOINTMENTS_CREATE_USER_APPOINTMENT_POSTURL,
  APPOINTMENTGROUPS_BY_DATE_GETURL,
  APPOINTMENT_EXCEL_RESULT_GETURL,
  APPOINTMENT_ALLUSER_EXCEL_RESULT_GETURL
} from '../../endpoints'
import {RequestManager} from '../../RequestManager'
import {GetAppointmentByIdOutput, GetAppointmentGroupsByDateOutput} from './models/getAppointmentModels'
import {CreateAppointmentInput, CreateUserAppointmentInput} from './models/createAppointmentModels'
import {UpdateAppointmentInput} from './models/updateAppointmentModels'
import axios, { AxiosError } from 'axios'
import moment from 'moment'

export const getAppointmentsByExpertId = async (expertId: number) => {
  const requestManager = new RequestManager()

  var res: Result<GetAppointmentByIdOutput[]> = {success: false, message: 'Hata', data: null}
  ////debugger
  return requestManager
    .get<Result<GetAppointmentByIdOutput[]>>(APPOINTMENTS_BY_EXPERTID_GETURL(expertId))
    .then((response) => {
      ////debugger
      res = response
      return res
    })
    .catch((error) => {
      res.message = error.message
      return res
    })
}

export const getAppointmentsByPatientId = async (patientId: number) => {
    const requestManager = new RequestManager()
  
    var res: Result<GetAppointmentByIdOutput[]> = {success: false, message: 'Hata', data: null}
    ////debugger
    return requestManager
      .get<Result<GetAppointmentByIdOutput[]>>(APPOINTMENTS_BY_PATIENTID_GETURL(patientId))
      .then((response) => {
        ////debugger
        res = response
        return res
      })
      .catch((error) => {
        res.message = error.message
        return res
      })
  }

  export const getAppointmentGroupsByDate = async () => {
    const requestManager = new RequestManager()
  
    var res: Result<GetAppointmentGroupsByDateOutput[]> = {success: false, message: 'Hata', data: null}
    ////debugger
    return requestManager
      .get<Result<GetAppointmentGroupsByDateOutput[]>>(APPOINTMENTGROUPS_BY_DATE_GETURL)
      .then((response) => {
        ////debugger
        res = response
        return res
      })
      .catch((error) => {
        res.message = error.message
        return res
      })
  }

  export const getAppointmentExcelResult = async (appointmentDate: Date) => {
    const res: Result<any> = {success: false, message: 'Hata', data: null}
  
    try {
      const response = await axios.get(APPOINTMENT_EXCEL_RESULT_GETURL(appointmentDate), {
        responseType: 'arraybuffer', // Dosyayı binary olarak almak için gerekli
      })
  
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
  
      const fileName = 'RandevuBilgileri_' + moment(appointmentDate).format('DD MMMM YYYY') + '.xlsx';
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName
      a.click()
      window.URL.revokeObjectURL(url)
  
      res.success = true
      return res
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError
        console.error('Axios Hatası:', axiosError.message)
      } else {
        console.error('Bilinmeyen Hata:', error)
      }
  
      res.message = 'Bilinmeyen hata'
      return res
    }
  }

  export const getAllUserAppointmentExcelResult = async (id: number) => {
    const res: Result<any> = {success: false, message: 'Hata', data: null}
  
    try {
      const response = await axios.get(APPOINTMENT_ALLUSER_EXCEL_RESULT_GETURL(id), {
        responseType: 'arraybuffer', // Dosyayı binary olarak almak için gerekli
      })
  
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
  
      const fileName = 'DanışanBilgileri.xlsx';
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName
      a.click()
      window.URL.revokeObjectURL(url)
  
      res.success = true
      return res
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError
        console.error('Axios Hatası:', axiosError.message)
      } else {
        console.error('Bilinmeyen Hata:', error)
      }
  
      res.message = 'Bilinmeyen hata'
      return res
    }
  }

  export const createUserAppointment = async (input: CreateUserAppointmentInput) => {
    const requestManager = new RequestManager()
  
    var res: Result<string> = {success: false, message: 'Hata', data: null}
    ////debugger
    return requestManager
      .post<Result<string>>(APPOINTMENTS_CREATE_USER_APPOINTMENT_POSTURL, input)
      .then((response) => {
        ////debugger
        res = response
        return res
      })
      .catch((error) => {
        res.message = error.message
        return res
      })
  }

  export const createAppointment = async (input: CreateAppointmentInput) => {
    const requestManager = new RequestManager()
  
    var res: Result<string> = {success: false, message: 'Hata', data: null}
    ////debugger
    return requestManager
      .post<Result<string>>(APPOINTMENTS_CREATE_APPOINTMENT_POSTURL, input)
      .then((response) => {
        ////debugger
        res = response
        return res
      })
      .catch((error) => {
        res.message = error.message
        return res
      })
  }

  export const updateAppointment = async (input: UpdateAppointmentInput) => {
    const requestManager = new RequestManager()
  
    var res: Result<string> = {success: false, message: 'Hata', data: null}
    ////debugger
    return requestManager
      .put<Result<string>>(APPOINTMENTS_UPDATE_PUTURL, input)
      .then((response) => {
        ////debugger
        res = response
        return res
      })
      .catch((error) => {
        res.message = error.message
        return res
      })
  }

  export const deleteAppointment = async (appointmentId: number) => {
    const requestManager = new RequestManager()
  
    var res: Result<string> = {success: false, message: 'Hata', data: null}
    ////debugger
    return requestManager
      .delete<Result<string>>(APPOINTMENTS_BY_ID_DELETEURL(appointmentId))
      .then((response) => {
        ////debugger
        res = response
        return res
      })
      .catch((error) => {
        res.message = error.message
        return res
      })
  }

